import Table from "@/components/Table/Table";
import { useProductRelationsPerYear } from "../useMaterials";

export default function ProductRelationsPerYearTable({ materialId }: { materialId: number }) {
  const { data, isLoading, isFetching } = useProductRelationsPerYear({ materialId });
  const loading = isLoading || isFetching;

  return (
    <div>
      <Table
        loading={loading}
        type="grey"
        data={data}
        emptyState={{ hide: true }}
        hideRaster={true}
        totalRows={data ? data.length : 4}
        columns={[
          {
            label: "Year",
            key: "year",
            renderer: (record) => (!record.year ? "Unrelated" : record.year),
          },
          {
            label: "Products",
            key: "product_count",
          },
        ]}
        rowKey={"year"}
      />
    </div>
  );
}
